export const FORGOT_USERID = "FORGOT_USERID";
export const GET_SECURITY_QS = "GET_SECURITY_QS";
export const PASSWORD_RECOVERY = "PASSWORD_RECOVERY";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const RESET_DATA = "RESET_DATA";
